import type { DiscountTypeAndAmount } from './types';
import { DiscountType } from './types';

export function formatDiscountAmount({
  discountAmount,
  discountType,
}: DiscountTypeAndAmount): string {
  return discountType === DiscountType.fixed
    ? `$${discountAmount} off`
    : `${discountAmount}% off`;
}
